import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faFilter,
  faLayerGroup,
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { PulseLoader } from "react-spinners";
import Swal from "sweetalert2";

import { APISD } from "../../../../../../../config/apisd";
import { APIMS } from "../../../../../../../config/apims";
import ToastError from "../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";
import ModalAdd from "./modal/add";
import ModalUpdate from "./modal/update";

import "bulma/css/bulma.css";
import "../../../../../../../index.css";

const pageStyles = `
  @keyframes predikatShimmer {
    0% { background-position: -700px 0; }
    100% { background-position: 700px 0; }
  }

  .predikat-filter-card {
    width: 100%;
    margin-bottom: 18px;
    padding: 18px;
    border: 1px solid #e6ebf4;
    border-radius: 14px;
    background: #ffffff;
    box-shadow: 0 4px 18px rgba(39, 71, 140, 0.06);
  }

  .predikat-filter-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
  }

  .predikat-filter-icon {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: #edf4ff;
    color: #315fba;
  }

  .predikat-filter-title {
    margin: 0;
    color: #1f2a44;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
  }

  .predikat-filter-subtitle {
    margin: 2px 0 0;
    color: #8a96aa;
    font-size: 12px;
    line-height: 1.35;
  }

  .predikat-filter-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px 12px;
    align-items: end;
  }

  .predikat-filter-field {
    min-width: 0;
  }

  .predikat-filter-label {
    display: block;
    margin-bottom: 7px;
    color: #4c5870;
    font-size: 12px;
    font-weight: 700;
  }

  .predikat-select-wrap {
    position: relative;
  }

  .predikat-select-wrap::after {
    content: "";
    position: absolute;
    right: 13px;
    top: 50%;
    width: 7px;
    height: 7px;
    border-right: 1.7px solid #72809a;
    border-bottom: 1.7px solid #72809a;
    transform: translateY(-68%) rotate(45deg);
    pointer-events: none;
  }

  .predikat-filter-select {
    width: 100%;
    height: 42px;
    padding: 0 36px 0 12px;
    border: 1px solid #dce3ef;
    border-radius: 9px;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    background: #ffffff;
    color: #2f3a50;
    font-size: 13px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .predikat-filter-select:hover:not(:disabled) {
    border-color: #b9c9e7;
  }

  .predikat-filter-select:focus {
    border-color: #4c78d3;
    box-shadow: 0 0 0 3px rgba(76, 120, 211, 0.12);
  }

  .predikat-filter-select:disabled {
    background: #f6f8fb;
    color: #9aa5b6;
    cursor: not-allowed;
  }

  .predikat-filter-button-field {
    display: flex;
    align-items: flex-end;
  }

  .predikat-filter-button {
    width: 100%;
    min-height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 16px;
    border: 1px solid #e9a51a;
    border-radius: 9px;
    background: #e9a51a;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(233, 165, 26, 0.2);
    transition: transform 0.15s ease, background 0.2s ease;
  }

  .predikat-filter-button:hover:not(:disabled) {
    transform: translateY(-1px);
    background: #d89512;
  }

  .predikat-filter-button:disabled {
    opacity: 0.58;
    cursor: not-allowed;
  }

  .predikat-shimmer {
    position: relative;
    overflow: hidden;
    background: linear-gradient(90deg, #e9eff8 8%, #f7f9fd 18%, #e9eff8 33%);
    background-size: 1100px 100%;
    animation: predikatShimmer 1.25s linear infinite;
  }

  .predikat-shimmer-label {
    width: 74px;
    height: 10px;
    margin-bottom: 8px;
    border-radius: 5px;
  }

  .predikat-shimmer-control,
  .predikat-shimmer-button {
    width: 100%;
    height: 42px;
    border-radius: 9px;
  }

  .predikat-search-section {
    margin-bottom: 14px;
  }

  .predikat-table {
    min-width: 680px;
  }

  .predikat-table .predikat-col-number {
    width: 78px;
  }

  .predikat-table .predikat-col-value {
    width: 180px;
  }

  .predikat-table .predikat-col-description {
    width: auto;
  }

  .predikat-table .predikat-col-action {
    width: 130px;
    text-align: center !important;
  }

  .predikat-value-badge {
    min-width: 58px;
    height: 31px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    border: 1px solid #d7e4fb;
    border-radius: 9px;
    background: #edf4ff;
    color: #315fba;
    font-size: 13px;
    font-weight: 800;
  }

  .predikat-description-text {
    display: block;
    width: 100%;
    color: #59667d;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.5;
    white-space: normal;
    overflow-wrap: break-word;
  }

  @media (max-width: 900px) and (min-width: 781px) {
    .predikat-filter-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 780px) {
    .predikat-filter-card {
      padding: 15px;
      border-radius: 12px;
    }

    .predikat-filter-grid {
      grid-template-columns: 1fr;
      gap: 11px;
    }

    .predikat-table {
      min-width: 640px;
    }

    .predikat-page .page-header-top {
      align-items: flex-start !important;
      flex-direction: column;
      gap: 14px;
    }

    .predikat-page .page-header-top .ml-auto {
      width: 100%;
      margin-left: 0 !important;
    }

    .predikat-page .module-header-button {
      width: 100%;
      justify-content: center;
    }
  }
`;

const getRows = (responseData) => {
  if (Array.isArray(responseData?.data?.data)) return responseData.data.data;
  if (Array.isArray(responseData?.data)) return responseData.data;
  if (Array.isArray(responseData?.result)) return responseData.result;
  if (Array.isArray(responseData)) return responseData;
  return [];
};

const getBranchId = (item) =>
  item?.branch_code || item?.id || item?.ysb_branch_id || "";

const getSchoolId = (item) =>
  item?.school_code || item?.id || item?.ysb_school_id || "";

const getLevelId = (item) => item?.id || item?.ysb_grade_level_id || "";

const isActive = (item) =>
  Number(item?.status) === 1 ||
  item?.is_active === true ||
  Number(item?.is_active) === 1;

export default function Predikat() {
  document.title = "Predikat Ekstrakurikuler";

  const token = localStorage.getItem("token");
  const storageLevel = localStorage.getItem("level") || "developer";

  const [semesterOptions, setSemesterOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [gradeLevelOptions, setGradeLevelOptions] = useState([]);

  const [loadingMaster, setLoadingMaster] = useState(true);
  const [loadingSchool, setLoadingSchool] = useState(false);
  const [loadingGradeLevel, setLoadingGradeLevel] = useState(false);

  const [filters, setFilters] = useState({
    ysb_academic_year_id: "",
    ysb_semester_id: "",
    ysb_branch_id: "",
    ysb_school_id: "",
    ysb_grade_level_id: "",
  });

  const [getData, setGetData] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tablePage, setTablePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isFetching, setIsFetching] = useState(false);
  const [hasLoadedData, setHasLoadedData] = useState(false);
  const hasAutoLoadedInitialData = useRef(false);

  const [modalAdd, setModalAdd] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const [id, setId] = useState("");
  const [dataUpdate, setDataUpdate] = useState(null);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type": "application/json",
      },
    }),
    [token]
  );

  const filterComplete = useMemo(
    () =>
      Boolean(
        filters.ysb_academic_year_id &&
          filters.ysb_semester_id &&
          filters.ysb_branch_id &&
          filters.ysb_school_id &&
          filters.ysb_grade_level_id
      ),
    [filters]
  );

  const selectedSemester = useMemo(
    () =>
      semesterOptions.find(
        (item) => String(item?.id) === String(filters.ysb_semester_id)
      ) || null,
    [filters.ysb_semester_id, semesterOptions]
  );

  const selectedBranch = useMemo(
    () =>
      branchOptions.find(
        (item) => String(getBranchId(item)) === String(filters.ysb_branch_id)
      ) || null,
    [branchOptions, filters.ysb_branch_id]
  );

  const selectedSchool = useMemo(
    () =>
      schoolOptions.find(
        (item) => String(getSchoolId(item)) === String(filters.ysb_school_id)
      ) || null,
    [filters.ysb_school_id, schoolOptions]
  );

  const selectedGradeLevel = useMemo(
    () =>
      gradeLevelOptions.find(
        (item) =>
          String(getLevelId(item)) === String(filters.ysb_grade_level_id)
      ) || null,
    [filters.ysb_grade_level_id, gradeLevelOptions]
  );

  const filterLabels = useMemo(
    () => ({
      academicYear: selectedSemester
        ? `${selectedSemester?.name_year || selectedSemester?.academic_year || "-"}${
            selectedSemester?.semester
              ? ` (Semester ${selectedSemester.semester})`
              : ""
          }`
        : "-",
      branch:
        selectedBranch?.branch_name || selectedBranch?.name_branch || "-",
      school:
        selectedSchool?.school_name || selectedSchool?.name_school || "-",
      gradeLevel:
        selectedGradeLevel?.name_level ||
        selectedGradeLevel?.grade_level_name ||
        "-",
    }),
    [selectedBranch, selectedGradeLevel, selectedSchool, selectedSemester]
  );

  const clearTable = useCallback(() => {
    setGetData([]);
    setHasLoadedData(false);
    setSearchKeyword("");
    setTablePage(1);
  }, []);

  const fetchInitialMaster = useCallback(async () => {
    setLoadingMaster(true);

    try {
      const [semesterResponse, branchResponse] = await Promise.all([
        APIMS.get("/api/access/semesters", {
          ...fetchParams,
          params: {
            page: 1,
            limit: 1000,
            ascending: 0,
            search: "",
            level: storageLevel,
          },
        }),
        APIMS.get("/api/access/branches", {
          ...fetchParams,
          params: {
            page: 1,
            limit: 1000,
            ascending: 1,
            search: "",
            level: storageLevel,
          },
        }),
      ]);

      const semesters = getRows(semesterResponse?.data).sort((first, second) => {
        const yearComparison = String(second?.name_year || "").localeCompare(
          String(first?.name_year || ""),
          "id",
          { numeric: true, sensitivity: "base" }
        );

        if (yearComparison !== 0) return yearComparison;
        return Number(first?.semester || 0) - Number(second?.semester || 0);
      });

      const branches = getRows(branchResponse?.data).sort((first, second) =>
        String(first?.branch_name || "").localeCompare(
          String(second?.branch_name || ""),
          "id",
          { numeric: true, sensitivity: "base" }
        )
      );

      setSemesterOptions(semesters);
      setBranchOptions(branches);

      const activeSemester = semesters.find(isActive) || semesters[0];
      const firstBranch = branches[0];

      setFilters((previous) => ({
        ...previous,
        ysb_academic_year_id:
          activeSemester?.ysb_academic_year_id || "",
        ysb_semester_id: activeSemester?.id || "",
        ysb_branch_id: getBranchId(firstBranch),
      }));
    } catch (error) {
      setSemesterOptions([]);
      setBranchOptions([]);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memuat data filter predikat",
      });
    } finally {
      setLoadingMaster(false);
    }
  }, [fetchParams, storageLevel]);

  useEffect(() => {
    fetchInitialMaster();
  }, [fetchInitialMaster]);

  const fetchSchoolsByBranch = useCallback(
    async (branchId) => {
      if (!branchId) {
        setSchoolOptions([]);
        setGradeLevelOptions([]);
        return;
      }

      setLoadingSchool(true);
      setSchoolOptions([]);
      setGradeLevelOptions([]);

      try {
        const response = await APIMS.get("/api/access/schools", {
          ...fetchParams,
          params: {
            page: 1,
            limit: 1000,
            ascending: 1,
            search: "",
            branch: branchId,
            level: storageLevel,
          },
        });

        let schools = getRows(response?.data);

        schools = schools.filter((item) => {
          const itemBranchId = item?.ysb_branch_id || item?.branch_code;
          return !itemBranchId || String(itemBranchId) === String(branchId);
        });

        if (String(branchId) === "BKS") {
          schools = schools.filter(
            (item) => String(getSchoolId(item)) !== "BASEMENT_BEKASI"
          );
        }

        const schoolOrder = ["SD", "SMP", "SMA"];
        schools = [...schools].sort((first, second) => {
          const firstName = String(first?.school_name || "").toUpperCase();
          const secondName = String(second?.school_name || "").toUpperCase();
          const firstOrder = schoolOrder.findIndex((level) =>
            firstName.includes(level)
          );
          const secondOrder = schoolOrder.findIndex((level) =>
            secondName.includes(level)
          );

          const safeFirstOrder = firstOrder === -1 ? 99 : firstOrder;
          const safeSecondOrder = secondOrder === -1 ? 99 : secondOrder;

          if (safeFirstOrder !== safeSecondOrder) {
            return safeFirstOrder - safeSecondOrder;
          }

          return firstName.localeCompare(secondName, "id", {
            numeric: true,
            sensitivity: "base",
          });
        });

        setSchoolOptions(schools);
        setFilters((previous) => ({
          ...previous,
          ysb_school_id: getSchoolId(schools[0]),
          ysb_grade_level_id: "",
        }));
      } catch (error) {
        setSchoolOptions([]);
        setGradeLevelOptions([]);
        setFilters((previous) => ({
          ...previous,
          ysb_school_id: "",
          ysb_grade_level_id: "",
        }));

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message || "Gagal memuat data sekolah",
        });
      } finally {
        setLoadingSchool(false);
      }
    },
    [fetchParams, storageLevel]
  );

  useEffect(() => {
    clearTable();
    setFilters((previous) => ({
      ...previous,
      ysb_school_id: "",
      ysb_grade_level_id: "",
    }));
    fetchSchoolsByBranch(filters.ysb_branch_id);
  }, [clearTable, fetchSchoolsByBranch, filters.ysb_branch_id]);

  const fetchGradeLevelsBySchool = useCallback(
    async (schoolId, branchId) => {
      if (!schoolId) {
        setGradeLevelOptions([]);
        return;
      }

      setLoadingGradeLevel(true);
      setGradeLevelOptions([]);

      try {
        const response = await APIMS.get("/api/grade-levels", {
          ...fetchParams,
          params: {
            page: 1,
            limit: 1000,
            ascending: 1,
            search: "",
            branch: branchId,
            level: storageLevel,
          },
          data: {
            page: 1,
            limit: 1000,
            ascending: true,
            search: "",
            ysb_branch_id: branchId,
            ysb_school_id: schoolId,
            level: storageLevel,
          },
        });

        let levels = getRows(response?.data);

        levels = levels.filter((item) => {
          const itemSchoolId = item?.ysb_school_id || item?.school_code;
          const itemBranchId = item?.ysb_branch_id || item?.branch_code;
          const schoolMatch =
            !itemSchoolId || String(itemSchoolId) === String(schoolId);
          const branchMatch =
            !itemBranchId || String(itemBranchId) === String(branchId);

          return schoolMatch && branchMatch;
        });

        levels = [...levels].sort((first, second) =>
          String(first?.name_level || "").localeCompare(
            String(second?.name_level || ""),
            "id",
            { numeric: true, sensitivity: "base" }
          )
        );

        setGradeLevelOptions(levels);
        setFilters((previous) => ({
          ...previous,
          ysb_grade_level_id: getLevelId(levels[0]),
        }));
      } catch (error) {
        setGradeLevelOptions([]);
        setFilters((previous) => ({
          ...previous,
          ysb_grade_level_id: "",
        }));

        ToastError.fire({
          icon: "error",
          title:
            error?.response?.data?.message || "Gagal memuat data tingkatan",
        });
      } finally {
        setLoadingGradeLevel(false);
      }
    },
    [fetchParams, storageLevel]
  );

  useEffect(() => {
    clearTable();
    setFilters((previous) => ({
      ...previous,
      ysb_grade_level_id: "",
    }));
    fetchGradeLevelsBySchool(
      filters.ysb_school_id,
      filters.ysb_branch_id
    );
  }, [
    clearTable,
    fetchGradeLevelsBySchool,
    filters.ysb_branch_id,
    filters.ysb_school_id,
  ]);

  const GetResponseData = useCallback(async () => {
    if (!filterComplete) {
      ToastError.fire({
        icon: "error",
        title: "Lengkapi tahun ajaran, cabang, sekolah, dan tingkatan",
      });
      return;
    }

    setIsFetching(true);

    const requestBody = {
      page: 1,
      limit: 1000,
      ascending: true,
      search: "",
      ysb_academic_year_id: filters.ysb_academic_year_id,
      ysb_semester_id: filters.ysb_semester_id,
      ysb_branch_id: filters.ysb_branch_id,
      ysb_school_id: filters.ysb_school_id,
      ysb_grade_level_id: filters.ysb_grade_level_id,
    };

    try {
      const response = await APISD.get("/api/ekstrakurikuler-predikat", {
        ...fetchParams,
        params: requestBody,
        data: requestBody,
      });

      if (response?.status === 200) {
        setGetData(getRows(response?.data));
        setHasLoadedData(true);
        setTablePage(1);
      }
    } catch (error) {
      setGetData([]);
      setHasLoadedData(true);

      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message ||
          "Gagal memuat data predikat ekstrakurikuler",
      });
    } finally {
      setIsFetching(false);
    }
  }, [fetchParams, filterComplete, filters]);

  useEffect(() => {
    if (
      hasAutoLoadedInitialData.current ||
      loadingMaster ||
      loadingSchool ||
      loadingGradeLevel ||
      !filterComplete
    ) {
      return;
    }

    hasAutoLoadedInitialData.current = true;
    GetResponseData();
  }, [
    GetResponseData,
    filterComplete,
    loadingGradeLevel,
    loadingMaster,
    loadingSchool,
  ]);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;

    clearTable();

    if (name === "ysb_semester_id") {
      const semester = semesterOptions.find(
        (item) => String(item?.id) === String(value)
      );

      setFilters((previous) => ({
        ...previous,
        ysb_semester_id: value,
        ysb_academic_year_id: semester?.ysb_academic_year_id || "",
      }));
      return;
    }

    setFilters((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  const deleteById = (predikatId) => {
    Swal.fire({
      title: "Apakah kamu yakin?",
      text: "Data yang dihapus tidak dapat dikembalikan.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Hapus",
      cancelButtonText: "Batal",
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          const response = await APISD.delete(
            `/api/ekstrakurikuler-predikat/${predikatId}`,
            fetchParams
          );

          if (response?.data?.error) {
            throw new Error(response?.data?.message);
          }

          return response;
        } catch (error) {
          Swal.showValidationMessage(
            error?.response?.data?.message ||
              error?.message ||
              "Gagal menghapus data"
          );

          return false;
        }
      },
    }).then((result) => {
      if (!result.isConfirmed) return;

      ToastSuccess.fire({
        icon: "success",
        title: "Data predikat berhasil dihapus",
      });

      GetResponseData();
    });
  };

  const filteredData = useMemo(() => {
    const keyword = searchKeyword.trim().toLowerCase();
    const source = Array.isArray(getData) ? getData : [];

    const rows = !keyword
      ? source
      : source.filter((item) => {
          const score = String(item?.predikat ?? "").toLowerCase();
          const description = String(item?.description || "").toLowerCase();
          return score.includes(keyword) || description.includes(keyword);
        });

    return [...rows].sort((first, second) => {
      const firstScore = Number(first?.predikat);
      const secondScore = Number(second?.predikat);

      if (!Number.isNaN(firstScore) && !Number.isNaN(secondScore)) {
        return firstScore - secondScore;
      }

      return String(first?.predikat || "").localeCompare(
        String(second?.predikat || ""),
        "id",
        { numeric: true, sensitivity: "base" }
      );
    });
  }, [getData, searchKeyword]);

  const totalRows = filteredData.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / Math.max(1, rowsPerPage)));

  useEffect(() => {
    setTablePage(1);
  }, [searchKeyword]);

  useEffect(() => {
    if (tablePage > totalPages) setTablePage(totalPages);
    if (tablePage < 1) setTablePage(1);
  }, [tablePage, totalPages]);

  const paginatedData = useMemo(() => {
    const start = (tablePage - 1) * rowsPerPage;
    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, rowsPerPage, tablePage]);

  const pageNumbers = useMemo(() => {
    const maxButtons = 5;
    const pages = [];

    if (totalPages <= maxButtons) {
      for (let page = 1; page <= totalPages; page += 1) pages.push(page);
      return pages;
    }

    const left = Math.max(1, tablePage - 1);
    const right = Math.min(totalPages, tablePage + 1);

    pages.push(1);
    if (left > 2) pages.push("...");

    for (let page = left; page <= right; page += 1) {
      if (page !== 1 && page !== totalPages) pages.push(page);
    }

    if (right < totalPages - 1) pages.push("...");
    pages.push(totalPages);

    return pages.filter(
      (value, index, array) => array.indexOf(value) === index
    );
  }, [tablePage, totalPages]);

  const goToPage = (nextPage) => {
    setTablePage(
      Math.min(Math.max(1, Number(nextPage) || 1), totalPages)
    );
  };

  const handleOpenAdd = () => {
    if (!filterComplete) {
      ToastError.fire({
        icon: "error",
        title: "Lengkapi filter sebelum menambah predikat",
      });
      return;
    }

    setModalAdd(true);
  };

  const viewModalUpdate = (predikatId, predikat) => {
    setId(predikatId);
    setDataUpdate(predikat);
    setModalUpdate(true);
  };

  const startRow =
    totalRows === 0
      ? 0
      : Math.min((tablePage - 1) * rowsPerPage + 1, totalRows);
  const endRow = Math.min(tablePage * rowsPerPage, totalRows);

  return (
    <div className="body module-page predikat-page">
      <style>{pageStyles}</style>

      {modalAdd && (
        <ModalAdd
          GetResponseData={GetResponseData}
          filterData={filters}
          filterLabels={filterLabels}
          show={modalAdd}
          onHide={() => setModalAdd(false)}
        />
      )}

      {modalUpdate && (
        <ModalUpdate
          GetResponseData={GetResponseData}
          id={id}
          dataUpdate={dataUpdate}
          filterData={filters}
          filterLabels={filterLabels}
          show={modalUpdate}
          onHide={() => {
            setModalUpdate(false);
            setId("");
            setDataUpdate(null);
          }}
        />
      )}

      <div className="page-header-card">
        <div className="page-header-top d-flex">
          <div className="page-title-wrap">
            <span className="page-title-icon">
              <FontAwesomeIcon icon={faLayerGroup} />
            </span>
            <h4 className="page-title-text">Predikat Ekstrakurikuler</h4>
          </div>

          {/* <div className="ml-auto">
            <button
              type="button"
              onClick={handleOpenAdd}
              className="btn btn-create module-header-button"
            >
              <FontAwesomeIcon icon={faPlus} />
              <span>Tambah Predikat</span>
            </button>
          </div> */}
        </div>

        <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
          <ol className="custom-breadcrumb">
            <li className="custom-breadcrumb-item">
              <Link to="/ekskuls">Ekstrakurikuler</Link>
            </li>
            <li className="custom-breadcrumb-separator">/</li>
            <li className="custom-breadcrumb-item active" aria-current="page">
              Predikat
            </li>
          </ol>
        </nav>
      </div>

      <div className="body-content module-content">
        <section className="predikat-filter-card">
          
          {loadingMaster ? (
            <div className="predikat-filter-grid">
              {Array.from({ length: 4 }).map((_, index) => (
                <div
                  className="predikat-filter-field"
                  key={`predikat-filter-shimmer-${index}`}
                >
                  {/* <div className="predikat-shimmer predikat-shimmer-label" /> */}
                  <div className="predikat-shimmer predikat-shimmer-control" />
                </div>
              ))}
              <div className="predikat-filter-field predikat-filter-button-field">
                <div className="predikat-shimmer predikat-shimmer-button" />
              </div>
            </div>
          ) : (
            <div className="predikat-filter-grid">
              <div className="predikat-filter-field">
                <label className="predikat-filter-label" htmlFor="predikat-year">
                  Tahun Ajaran
                </label>
                <div className="predikat-select-wrap">
                  <select
                    id="predikat-year"
                    name="ysb_semester_id"
                    className="predikat-filter-select"
                    value={filters.ysb_semester_id}
                    onChange={handleFilterChange}
                  >
                    <option value="">Pilih Tahun Ajaran</option>
                    {semesterOptions.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.name_year || item?.academic_year || "Tahun Ajaran"}
                        {item?.semester ? ` (Semester ${item.semester})` : ""}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="predikat-filter-field">
                <label className="predikat-filter-label" htmlFor="predikat-branch">
                  Cabang
                </label>
                <div className="predikat-select-wrap">
                  <select
                    id="predikat-branch"
                    name="ysb_branch_id"
                    className="predikat-filter-select"
                    value={filters.ysb_branch_id}
                    onChange={handleFilterChange}
                  >
                    <option value="">Pilih Cabang</option>
                    {branchOptions.map((item) => (
                      <option key={getBranchId(item)} value={getBranchId(item)}>
                        {item?.branch_name || item?.name_branch || "Cabang"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="predikat-filter-field">
                <label className="predikat-filter-label" htmlFor="predikat-school">
                  Sekolah
                </label>
                <div className="predikat-select-wrap">
                  <select
                    id="predikat-school"
                    name="ysb_school_id"
                    className="predikat-filter-select"
                    value={filters.ysb_school_id}
                    onChange={handleFilterChange}
                    disabled={loadingSchool || !filters.ysb_branch_id}
                  >
                    <option value="">
                      {loadingSchool ? "Memuat sekolah..." : "Pilih Sekolah"}
                    </option>
                    {schoolOptions.map((item) => (
                      <option key={getSchoolId(item)} value={getSchoolId(item)}>
                        {item?.school_name || item?.name_school || "Sekolah"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="predikat-filter-field">
                <label className="predikat-filter-label" htmlFor="predikat-level">
                  Tingkatan
                </label>
                <div className="predikat-select-wrap">
                  <select
                    id="predikat-level"
                    name="ysb_grade_level_id"
                    className="predikat-filter-select"
                    value={filters.ysb_grade_level_id}
                    onChange={handleFilterChange}
                    disabled={loadingGradeLevel || !filters.ysb_school_id}
                  >
                    <option value="">
                      {loadingGradeLevel
                        ? "Memuat tingkatan..."
                        : "Pilih Tingkatan"}
                    </option>
                    {gradeLevelOptions.map((item) => (
                      <option key={getLevelId(item)} value={getLevelId(item)}>
                        {item?.name_level || item?.grade_level_name || "Tingkatan"}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="predikat-filter-field predikat-filter-button-field">
                <button
                  type="button"
                  className="predikat-filter-button"
                  onClick={GetResponseData}
                  disabled={
                    isFetching ||
                    loadingSchool ||
                    loadingGradeLevel ||
                    !filterComplete
                  }
                >
                  {isFetching ? (
                    <PulseLoader color="#ffffff" size={5} />
                  ) : (
                    <>
                      <span>Tampilkan Data</span>
                    </>
                  )}
                </button>
              </div>

              <div className="predikat-filter-field predikat-filter-button-field">
                <button
                  type="button"
                  className="predikat-filter-button"
                  onClick={handleOpenAdd}
                  disabled={
                    isFetching ||
                    loadingSchool ||
                    loadingGradeLevel ||
                    !filterComplete
                  }
                  style={{backgroundColor: "#3f5bea"}}
                >
                  {isFetching ? (
                    <PulseLoader color="#ffffff" size={5} />
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faPlus} />
                  <span>Tambah Predikat</span>
                    </>
                  )}
                </button>
              </div>
              
              {/* <button
                  type="button"
                  onClick={handleOpenAdd}
                  className="btn btn-create module-header-button"
                >
                  <FontAwesomeIcon icon={faPlus} />
                  <span>Tambah Predikat</span>
                </button>
               */}
            </div>
          )}
        </section>

        <div className="module-search-wrap predikat-search-section">
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            className="module-search-icon"
          />
          <input
            type="text"
            className="module-search-input"
            placeholder="Cari nilai atau keterangan predikat..."
            value={searchKeyword}
            onChange={(event) => setSearchKeyword(event.target.value)}
          />
        </div>

        <div className="module-table-card">
          <div className="module-table-scroll">
            <table className="module-table predikat-table">
              <thead>
                <tr>
                  <th className="module-col-number predikat-col-number">No</th>
                  <th className="predikat-col-value">Nilai</th>
                  <th className="predikat-col-description">Predikat</th>
                  <th className="module-col-action predikat-col-action">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody>
                {isFetching ? (
                  <tr>
                    <td colSpan="4" className="module-empty-state">
                      <div className="module-empty-state-content">
                        <PulseLoader color="#3f5bea" size={9} />
                      </div>
                    </td>
                  </tr>
                ) : paginatedData.length > 0 ? (
                  paginatedData.map((row, index) => (
                    <tr key={row?.id || index}>
                      <td className="module-col-number predikat-col-number">
                        <span className="module-number-badge">
                          {(tablePage - 1) * rowsPerPage + index + 1}
                        </span>
                      </td>

                      <td>
                        <span className="predikat-value-badge">
                          {row?.predikat ?? "-"}
                        </span>
                      </td>

                      <td>
                        <span className="predikat-description-text">
                          {row?.description || "-"}
                        </span>
                      </td>

                      <td className="module-col-action predikat-col-action">
                        <div className="module-action-wrap">
                          <button
                            type="button"
                            className="module-action-button module-action-edit"
                            onClick={() => viewModalUpdate(row?.id, row)}
                            title="Ubah predikat"
                            aria-label={`Ubah predikat ${row?.predikat ?? ""}`}
                          >
                            <FontAwesomeIcon icon={faPenToSquare} />
                          </button>

                          <button
                            type="button"
                            className="module-action-button module-action-delete"
                            onClick={() => deleteById(row?.id)}
                            title="Hapus predikat"
                            aria-label={`Hapus predikat ${row?.predikat ?? ""}`}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="module-empty-state">
                      <div className="module-empty-state-content">
                        {hasLoadedData
                          ? "Data tidak ditemukan"
                          : "Pilih filter lalu klik Tampilkan Data"}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {!isFetching && filteredData.length > 0 && (
            <div className="module-pagination">
              <div className="module-pagination-left">
                <span className="module-page-info">
                  Menampilkan <b>{startRow}</b>-<b>{endRow}</b> dari{" "}
                  <b>{totalRows}</b> data
                </span>

                <select
                  className="module-page-size"
                  value={rowsPerPage}
                  onChange={(event) => {
                    setRowsPerPage(Number(event.target.value) || 10);
                    setTablePage(1);
                  }}
                >
                  <option value={10}>10 / halaman</option>
                  <option value={25}>25 / halaman</option>
                  <option value={50}>50 / halaman</option>
                  <option value={100}>100 / halaman</option>
                </select>
              </div>

              <div className="module-pagination-right">
                <button
                  type="button"
                  className="module-page-nav"
                  onClick={() => goToPage(tablePage - 1)}
                  disabled={tablePage <= 1}
                  aria-label="Halaman sebelumnya"
                >
                  <FontAwesomeIcon icon={faChevronLeft} />
                  <span>Sebelumnya</span>
                </button>

                <div className="module-page-numbers">
                  {pageNumbers.map((page, index) =>
                    page === "..." ? (
                      <span key={`dots-${index}`} className="module-page-dots">
                        ...
                      </span>
                    ) : (
                      <button
                        type="button"
                        key={`page-${page}`}
                        className={`module-page-number ${
                          page === tablePage ? "active" : ""
                        }`}
                        onClick={() => goToPage(page)}
                      >
                        {page}
                      </button>
                    )
                  )}
                </div>

                <button
                  type="button"
                  className="module-page-nav"
                  onClick={() => goToPage(tablePage + 1)}
                  disabled={tablePage >= totalPages}
                  aria-label="Halaman berikutnya"
                >
                  <span>Selanjutnya</span>
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
